export default [
  {
    path: "/app/:userDeptRoleId/discussion",
    components: {
      default: () => import("../views/discuss/index.vue")
    },
    name: "discussion"
  },
  {
    path: "/app/:userDeptRoleId/discussion/detail/:id",
    components: {
      default: () => import("../views/discuss/index.vue"),
      detail: () => import("../views/discuss/detail.vue"),
    },
    name: "discussionDetail"
  },
];



// WEBPACK FOOTER //
// ./src/router/discussion.js